import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"
import SidebarNav from "../components/sidebarNav"

const WhatIOfferPage = ({ location }) => {
  return (
    <Layout isHome={false}>
      <Head
        title="What I Offer"
        description=" Information about the different kinds of sessions I offer and what therapy means to me."
      />
      <h2>What I Offer</h2>
      <SidebarNav location={location} />
    </Layout>
  )
}

export default WhatIOfferPage
